import { requestUtil } from '../../utils';
export function getOrgsByEmployeeId(data) {
  return requestUtil("/api/uims/v1/org/auth/".concat(data.orgId, "/dept/list"), {
    method: 'get'
  });
}